export default __webpack_public_path__ + "static/media/rounded-rectangle.83db53f7.svg";